import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { CopyIcon, PrintIcon, UploadIcon } from "@gemini/icons";
import { useI18n } from "@/contexts/i18n";
import { FavoriteHeart } from "@seeker-consumer-portal/favorite-heart";
import { useIsDesktop, useShare, useFavoriteTracking, useFeatureEnabled, } from "@/hooks";
import { useClassifiedId } from "@/contexts/classified";
import { useBrowserPrint } from "@/hooks/useBrowserPrint";
import { useConfig } from "@/contexts/cdpConfig";
export const CTAs = ({ display = "flex", dark, showPrint, showBorder, }) => {
    const classifiedId = useClassifiedId();
    const { t } = useI18n();
    const { copyShare, nativeMobileShare } = useShare();
    const isDesktop = useIsDesktop();
    const { onBrowserPrint } = useBrowserPrint();
    const inverted = dark ? "-inverted" : "";
    const favoriteTracking = useFavoriteTracking();
    const favoriteEnabled = useFeatureEnabled("favorites");
    const isPreviewMode = useConfig().previewMode;
    const getMinWidth = () => {
        if (isDesktop) {
            return showPrint ? "sizing.142" : "sizing.96";
        }
        else {
            return "sizing.80";
        }
    };
    const minWidth = getMinWidth();
    return (_jsxs(Box, { display: display, height: "sizing.40", minWidth: minWidth, alignItems: "flex-start", justifyContent: "right", id: "favoriteAndShareCTAs", marginLeft: "auto", children: [showPrint && isDesktop && (_jsx(Box, { display: "flex", marginHorizontal: "4px", width: "sizing.40", children: _jsx(Button, { icon: PrintIcon, iconOnly: true, size: "40", onPress: onBrowserPrint, position: "absolute", variant: isDesktop ? `secondary${inverted}` : `tertiary${inverted}`, children: t("common.CTA.print.label") }) })), _jsx(Box, { display: "flex", marginHorizontal: "4px", width: "sizing.40", children: _jsx(Button, { onPress: isDesktop ? copyShare : nativeMobileShare, icon: isDesktop ? CopyIcon : UploadIcon, iconOnly: true, variant: showBorder ? `secondary${inverted}` : `tertiary${inverted}`, size: "40", isDisabled: isPreviewMode, children: t("common.CTA.share.label") }) }), favoriteEnabled && !isPreviewMode && (_jsx(Box, { display: "flex", marginHorizontal: "4px", width: "sizing.40", children: _jsx(FavoriteHeart, { classifiedId: classifiedId, tracking: favoriteTracking, border: showBorder, black: dark }) }))] }));
};
